import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TrueGrit} from "../../TrueGrit";
import {gsap, TimelineMax} from "gsap";
import {TrueGritSymbol} from "../../reels/TrueGritSymbol";
import {TrueGritSound} from "../../sound/TrueGritSound";

/**
 * Created by Jerker Nord on 2021-10-28.
 */

export class TrueGritXWaysRunner implements SimplePresentation {

    private _mainTL:TimelineMax;

    shouldRun():boolean {
        if(TrueGrit.model.gameData.xWays || TrueGrit.model.mainReelXWays.length > 0) {
            return true;
        }
        return false;
    }

    start(controller:SimplePresentationRunnerController):void {
        this._mainTL = gsap.timeline({onComplete : controller.finish});

        if(TrueGrit.model.gameData.xWays && TrueGrit.model.gameData.xWays.isInfectious) {
            //1. PLay all main reel XWays first
            //2. Play infectious
            for(let i:number = 0; i < TrueGrit.model.mainReelXWays.length; i++) {
                this._mainTL.add(()=>TrueGrit.soundPlayer.playXWaySplit(TrueGritSymbol.isLowWin(TrueGrit.model.mainReelXWays[i].symbolName)));
                this._mainTL.add(() => {
                    (<TrueGritSymbol>TrueGrit.allReelsView.mainReelModels[TrueGrit.model.mainReelXWays[i].position.x].reelView.getSymbol(TrueGrit.model.mainReelXWays[i].position.y)).getSplitAndChangeAnimation(TrueGrit.model.mainReelXWays[i].splitLevel, TrueGrit.model.mainReelXWays[i].symbolName, false, false)
                });
            }
            if(TrueGrit.model.mainReelXWays.length > 0) {
                this._mainTL.add(() => {}, "+=" + 0.8);
            }
            let infectiousPositions:PIXI.Point[] = [];
            for(let i:number = 0; i < 3; i++) {
                if(TrueGrit.model.gameData.botTrain.isRevealed[i]) {
                    //It's infectious!
                    if(TrueGrit.allReelsView.bottomReelModel.reelView.getSymbolBySymbolPosition(i + 1).symbolName == "M_infectious") {
                        for(let j:number = 0; j < TrueGrit.model.gameData.xWays.infectedPositions.length; j++) {
                            for(let k:number = 1; k < TrueGrit.model.gameData.xWays.infectedPositions[j].length; k++) {
                                if(TrueGrit.model.gameData.xWays.infectedPositions[j][k]) {
                                    infectiousPositions.push(new PIXI.Point(j, k - 1));
                                }
                            }
                        }
                        //1. Get infectious reveal animations
                        this._mainTL.add([
                            ...TrueGrit.splitSymbolView.getInfectiousRevealAnimations(),
                            ()=>{TrueGrit.soundPlayer.playSound(TrueGritSound.XWAYS_INFECTIOUS_REVEAL)}
                        ]);

                        //2. Get attention animations
                        this._mainTL.add([
                            ...TrueGrit.splitSymbolView.getInfectiousAttentionAnimations(infectiousPositions),
                        ], "+=0.4");

                        //3. Get infect sym animations (including bottom reel)
                        const anims:gsap.core.Timeline[] = TrueGrit.splitSymbolView.getInfectedRevealAnimations(infectiousPositions);
                        this._mainTL.add(anims);

                        if (anims.length > 1){
                            this._mainTL.add(()=>TrueGrit.soundPlayer.playInfectiousSplit(TrueGritSymbol.isLowWin(TrueGrit.model.gameData.xWays.symbol)),"<");
                        }
                        break;
                    }
                }
            }
        } else {
            //play all main reel and bottom reel xways at the same time

            let finalRevealSymbol:string = "";
            for(let i:number = 0; i < TrueGrit.model.mainReelXWays.length; i++) {
                finalRevealSymbol = TrueGrit.model.mainReelXWays[0].symbolName;
                this._mainTL.add(() => {
                    (<TrueGritSymbol>TrueGrit.allReelsView.mainReelModels[TrueGrit.model.mainReelXWays[i].position.x].reelView.getSymbol(TrueGrit.model.mainReelXWays[i].position.y)).getSplitAndChangeAnimation(TrueGrit.model.mainReelXWays[i].splitLevel, TrueGrit.model.mainReelXWays[i].symbolName, false, false)
                });
            }


            for(let i:number = 0; i < 3; i++) {
                if(TrueGrit.allReelsView.bottomReelModel.reelView.getSymbolBySymbolPosition(i + 1).symbolName == "M" && TrueGrit.model.gameData.botTrain.isRevealed[i]) {
                    //One or more non-infectious M on bottom reel
                    this._mainTL.add(() => {
                        (<TrueGritSymbol>TrueGrit.allReelsView.bottomReelModel.reelView.getSymbolBySymbolPosition(i + 1)).getSplitAndChangeAnimation(TrueGrit.model.gameData.xWays.sizeSymbol, TrueGrit.model.gameData.xWays.symbol, true, false)
                    })
                    finalRevealSymbol = TrueGrit.model.gameData.xWays.symbol;
                }
            }

            if (finalRevealSymbol != ""){
                this._mainTL.add(()=>TrueGrit.soundPlayer.playXWaySplit(TrueGritSymbol.isLowWin(finalRevealSymbol)), "<");
            }
        }

        this._mainTL.add(() => {TrueGrit.waysView.updateNumberOfWays();}, "+=0.4");
        this._mainTL.add(() => {}, "+=0.4");


        if(this._mainTL.duration() == 0) {
            this._mainTL.add(gsap.to(this, {duration : 0.001}));
        }
    }
}